import React, { useCallback } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Selections from "../../common/Selections";
import List from "../../common/List";

/**
 * TABLE SYSTEMCOLORS
 */
function UserLanguages(props) {
  const IdUser = props.sysUser.idUser;

  return (
    <Selections
      className="unlock-overflow"
      title="User Language"
      // GET
      getUrl={"/User/GetLanguages"}
      // SELECTED
      getSelectedUrl={`/User/UsersLanguage_GetLanguageList?idUser=${IdUser}`}
      getSelectedParams={() => props.Profile}
      getSelectedProcess={(data = []) =>
        data.filter(({ checked }) => checked).map(({ idLanguage }) => idLanguage)
      }
      // INSERT
      insertUrl={"/User/UsersLanguage_Insert"}
      insertParams={({ userId: CurrentuserId }, { idLanguage }) => ({
        userId: IdUser,
        IdLanguage: idLanguage,
        IdUser: Number(CurrentuserId),
      })}
      // DELETE
      deleteUrl={"/User/UsersLanguage_Delete"}
      deleteParams={({ userId: CurrentuserId }, { idLanguage }) => ({
        userId: IdUser,
        IdLanguage: idLanguage,
        IdUser: Number(CurrentuserId),
      })}
    >
      <TableHeaderColumn visible="none" isKey={true} hidden dataField="idLanguage">
        IdLanguage
      </TableHeaderColumn>
      <TableHeaderColumn dataField="langDesc">Language</TableHeaderColumn>
    </Selections>
  );
}

export default UserLanguages;
